import { RSAA } from 'redux-api-middleware';

import { toFormData } from '../../helpers/requestHelper';
import { CreateJobRequestDataProps } from '../../components/clipGeneratorV2/jobs/createJobForm.types';

const BASE_ROUTE = '/after-effects/generator-jobs';
const LIVE_CLIP_BASE_ROUTE = '/after-effects/generator-jobs/live-clips';

const GET_AFTER_EFFECTS_GENERATOR_JOBS_REQUEST = 'GET_GENERATOR_JOBS_REQUEST';
const GET_AFTER_EFFECTS_GENERATOR_JOBS_SUCCESS = 'GET_GENERATOR_JOBS_SUCCESS';
const GET_AFTER_EFFECTS_GENERATOR_JOBS_FAILURE = 'GET_GENERATOR_JOBS_FAILURE';

export const getAfterEffectsGeneratorJobs = () => ({
  [RSAA]: {
    types: [
      GET_AFTER_EFFECTS_GENERATOR_JOBS_REQUEST,
      GET_AFTER_EFFECTS_GENERATOR_JOBS_SUCCESS,
      GET_AFTER_EFFECTS_GENERATOR_JOBS_FAILURE,
    ],
    endpoint: `${BASE_ROUTE}`,
    method: 'GET',
  },
});

const POST_AFTER_EFFECTS_GENERATOR_JOBS_REQUEST = 'POST_GENERATOR_JOBS_REQUEST';
const POST_AFTER_EFFECTS_GENERATOR_JOBS_SUCCESS = 'POST_GENERATOR_JOBS_SUCCESS';
const POST_AFTER_EFFECTS_GENERATOR_JOBS_FAILURE = 'POST_GENERATOR_JOBS_FAILURE';

export const postAfterEffectsGeneratorJob = (body: CreateJobRequestDataProps) => ({
  [RSAA]: {
    types: [
      POST_AFTER_EFFECTS_GENERATOR_JOBS_REQUEST,
      POST_AFTER_EFFECTS_GENERATOR_JOBS_SUCCESS,
      POST_AFTER_EFFECTS_GENERATOR_JOBS_FAILURE,
    ],
    endpoint: `${BASE_ROUTE}`,
    method: 'POST',
    body: toFormData(body),
  },
});

export const postAfterEffectsLiveGeneratorJob = (body: CreateJobRequestDataProps) => ({
  [RSAA]: {
    types: [
      POST_AFTER_EFFECTS_GENERATOR_JOBS_REQUEST,
      POST_AFTER_EFFECTS_GENERATOR_JOBS_SUCCESS,
      POST_AFTER_EFFECTS_GENERATOR_JOBS_FAILURE,
    ],
    endpoint: `${LIVE_CLIP_BASE_ROUTE}`,
    method: 'POST',
    body: toFormData(body),
  },
});

const DELETE_AFTER_EFFECTS_GENERATOR_JOBS_REQUEST = 'DELETE_GENERATOR_JOBS_REQUEST';
const DELETE_AFTER_EFFECTS_GENERATOR_JOBS_SUCCESS = 'DELETE_GENERATOR_JOBS_SUCCESS';
const DELETE_AFTER_EFFECTS_GENERATOR_JOBS_FAILURE = 'DELETE_GENERATOR_JOBS_FAILURE';

export const deleteAfterEffectsJob = (jobId: string) => ({
  [RSAA]: {
    types: [
      DELETE_AFTER_EFFECTS_GENERATOR_JOBS_REQUEST,
      DELETE_AFTER_EFFECTS_GENERATOR_JOBS_SUCCESS,
      DELETE_AFTER_EFFECTS_GENERATOR_JOBS_FAILURE,
    ],
    endpoint: `${BASE_ROUTE}/${jobId}`,
    method: 'DELETE',
  },
});
